module.exports = __webpack_public_path__ + "static/media/img9.da877dc2.svg";